<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 左侧主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --download">
          <div class="widjet__head">
            <h3 class="uk-text-lead">下载加速软件</h3>
          </div>
          <div class="widjet__body">
            <div class="download-section">
              <!-- 头部图片 -->
              <img src="@/assets/img/ss1726677487.png" alt="下载客户端" class="header-img" />

              <!-- 选择系统 -->
              <h2 class="section-title">📥 请选择对应系统下载</h2>
              <ul class="download-list">
                <li v-for="(system, index) in systems" :key="index">
                  <a :href="system.link" target="_blank" class="download-btn">{{ system.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加信息 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">续费 & 常见问题</h3>
          </div>
          <div class="widjet__body">
            <!-- 续费教程 -->
            <div class="section">
              <h2 class="section-title">💳 续费教程</h2>
              <a href="profile" target="_blank" class="faq-link">点我查看</a>
            </div>

            <!-- 官网地址 -->
            <div class="section">
              <h2 class="section-title">🌍 续费官网地址</h2>
              <p>
                <strong>官网①：</strong>
                <a href="https://ok.realsulian.com" target="_blank" class="faq-link">https://ok.realsulian.com</a>
              </p>
              <p>
                <strong>备用官网②：</strong>
                <a href="https://ok.goodsulian.com/" target="_blank" class="faq-link">点我查看</a>
              </p>
            </div>

            <!-- 备用入口 -->
            <div class="section">
              <h2 class="section-title">🔗 备用入口</h2>
              <a href="https://ok.realsulian.com" target="_blank" class="faq-link">点击进入备用入口</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "DownloadPage",
  data() {
    return {
      systems: [
        { name: "苹果手机 | iOS | iPad", link: "pgios" },
        { name: "安卓手机 | 鸿蒙 | 模拟器", link: "anzhuo" },
        { name: "PC 电脑 | Windows", link: "jcwin" },
        { name: "苹果电脑 | Mac OS", link: "macios" },
      ],
    };
  },
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 头部图片 */
.header-img {
  width: 100%;
  max-width: 700px;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
}

/* 🌟 下载列表 */
.download-list {
  list-style: none;
  padding: 0;
}

.download-list li {
  margin-bottom: 10px;
}

/* 🌟 下载按钮 */
.download-btn {
  display: block;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: rgb(0, 112, 192);
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
  text-align: center;
}

.download-btn:hover {
  background-color: rgb(0, 85, 150);
}

/* 🌟 标题样式 */
.section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-bottom: 10px;
}

/* 🌟 续费教程链接 */
.faq-link {
  font-size: 18px;
  color: rgb(192, 0, 0);
  text-decoration: none;
}

.faq-link:hover {
  text-decoration: underline;
}
</style>
